import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import styles from "./MoveMinersModal.module.scss";
import { InjectedProps } from "redux-modal";
import { PropsWithChildren, useState } from "react";
import { Tab } from "@store/minersSelect/actionTypes";
import { Button } from "antd";
import { MODALS_ENUM } from "@constants/Modals";
import { MinersTabSelect } from "@components/global/new/MinersTabSelect/MinersTabSelect";

type MoveMinersModalProps = {
  onApply?: { (targetTabId: Tab): void };
} & CommonModalPropsI & PropsWithChildren<InjectedProps>;

function MoveMinersModal(props: MoveMinersModalProps) {
  const [target, setTarget] = useState<Tab>(Tab.ALL);

  return <div className={styles.wrap}>
    <div className={styles.title}>
      <h4>
        {props.formatMessage({ id: "modal.moveMiners.title" })}
      </h4>
    </div>
    <MinersTabSelect
      value={target}
      onChange={setTarget}
    />
    <div className={styles.buttons}>
        <Button
          type="primary"
          onClick={() => {
            props.onApply?.(target);
            props.handleClose();
          }}
        >
          {props.formatMessage({ id: "modal.moveMiners.actions.ok" })}
        </Button>
        <Button onClick={props.handleClose}>
          {props.formatMessage({ id: "modal.moveMiners.actions.cancel" })}
        </Button>
      </div>
  </div>
}

export default WithModal(MODALS_ENUM.MOVE_MINERS_MODAL, MoveMinersModal);
